var ServiceTableHeaderLabels = {
  cpus: "CPU",
  disk: "DISK",
  mem: "MEM",
  name: "NAME",
  status: "STATUS"
};

module.exports = ServiceTableHeaderLabels;



// WEBPACK FOOTER //
// ./plugins/services/src/js/constants/ServiceTableHeaderLabels.js